import agent from '../../../../api/agent';
import { Static } from '../../../../static';
import { EtichettaValore } from '../../../../models/etichetta-valore';
import { DatiBolletta } from '../models/dati-bolletta';
import DownloadPdf from './DownloadPdf';
import { BILL_DATA_TARGET_ID, SUPPLY_DETAILS_TARGET_ID } from './SkipLinks';

type Props = {
	isSingleDocument: boolean;
	importoTotaleContratto: EtichettaValore;
	scadenzaBolletta: EtichettaValore;
	documentoN: EtichettaValore;
	documentoPeriodo: EtichettaValore;
	datiBolletta: DatiBolletta;
	consumoFatturato?: EtichettaValore;
};

const DocumentDetail = (props: Props) => {
	const showDetails = async () => {
		agent.Tracking.track(
			Static.onShowDetails + ' ' + Static.fromDocumentDetailComponent
		);

		const el = document.getElementById(SUPPLY_DETAILS_TARGET_ID);
		if (el) {
			el.focus({ preventScroll: true });
			el.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest',
			});
		}
	};

	return (
		<div
			id={BILL_DATA_TARGET_ID}
			className='app-skip-target'
			tabIndex={-1}
		>
			<div id='document-detail'>
			{props.isSingleDocument ? (
				<div className='card p-5'>
					<div className='mb-3'>
						<div className='app-value-heading'>
							{props.importoTotaleContratto.Valore} €
						</div>
						<p className='app-p-bigger'>
							{props.importoTotaleContratto.Etichetta}
						</p>
					</div>
					<div className='mb-3'>
						<div className='app-value-heading'>
							{props.scadenzaBolletta.Valore}
						</div>
						<p className='app-p-bigger'>{props.scadenzaBolletta.Etichetta}</p>
					</div>
					{props.consumoFatturato && (
						<div className='mb-3'>
							<div className='app-value-heading'>
								{props.consumoFatturato.Valore} mc
							</div>
							<p className='app-p-bigger'>{props.consumoFatturato.Etichetta}</p>
						</div>
					)}
					<button
						className='btn app-btn-details mb-3'
						onClick={showDetails}
						aria-label='Altri dettagli della fornitura'
					>
						Altri dettagli
					</button>
					<hr />
					<div className='row mt-3'>
						<div className='col-6'>
							<div>
								{props.documentoN.Etichetta}
								<p className='app-bold'>{props.documentoN.Valore}</p>
							</div>
						</div>
						<div className='col-6'>
							<div>
								{props.documentoPeriodo.Etichetta}
								<p className='app-bold'>{props.documentoPeriodo.Valore}</p>
							</div>
						</div>
					</div>
					<DownloadPdf datiBolletta={props.datiBolletta} />
				</div>
			) : (
				<div className='p-5 app-detail-box'>
					<h2 className='app-detail-title mb-3 mb-md-5'>
						Dettaglio {props.documentoN.Etichetta} {props.documentoN.Valore}
					</h2>
					<div className='mt-3 mt-md-5'>
						{props.importoTotaleContratto.Etichetta}
						<p className='app-bold'>{props.importoTotaleContratto.Valore} €</p>
					</div>
					<div>
						{props.scadenzaBolletta.Etichetta}
						<p className='app-bold'>{props.scadenzaBolletta.Valore}</p>
					</div>
					{props.consumoFatturato && (
						<div>
							{props.consumoFatturato.Etichetta}
							<p className='app-bold'>{props.consumoFatturato.Valore} mc</p>
						</div>
					)}
					<div>
						{props.documentoPeriodo.Etichetta}
						<p className='app-bold'>{props.documentoPeriodo.Valore}</p>
					</div>
					<button
						className='btn app-btn-details mb-3'
						onClick={showDetails}
						aria-label='Altri dettagli della fornitura'
					>
						Altri dettagli
					</button>
				</div>
			)}
			</div>
		</div>
	);
};

export default DocumentDetail;
